import { makeStyles, TableCell, TableHead, TableRow, Typography } from "@material-ui/core";

const useStyle = makeStyles((theme) => ({
  firstCell: {
    position: "sticky",
    left: 0,
    zIndex: 1,
    backgroundColor: theme.palette.background.headerDefault,
  },
  cell: {
    cursor: "pointer",
    backgroundColor: theme.palette.background.headerDefault,
  },
}));

export default function MarketEventTableHeader() {
  const cls = useStyle();

  const columns = [
    { id: "type", label: "Type", classes: cls.firstCell, style: { minWidth: 25 } },
    { id: "date", label: "Date time", classes: cls.cell, style: { minWidth: 100 } },
    { id: "amount", label: "Amount(USD)", classes: cls.cell, style: { minWidth: 50 } },
    { id: "user", label: "User", classes: cls.cell, style: { minWidth: 25 } },
    { id: "token", label: "Token", classes: cls.cell, style: { minWidth: 25 } },
    { id: "transaction", label: "Transaction", classes: cls.cell, style: { minWidth: 25 } },
  ];

  return (
    <TableHead>
      <TableRow>
        {columns.map((element) => {
          return (
            <TableCell key={element.id} className={element?.classes} style={element?.style}>
              <Typography>{element.label}</Typography>
            </TableCell>
          );
        })}
      </TableRow>
    </TableHead>
  );
}
